define('location',[
    "jquery",
    "logging",
    "storage",
    "utilities"
], function ($, logging, storage, utilities) {
    var _ModuleName = "Location Library";

    var _config = {
        api: {
            endpoint: "//www.patheos.com/ptapi/location/findme",
            ipApiEndpoint: "http://ip-api.com/json/?fields=countryCode,region", // 45 requests per min from an IP - No SSL unless paying
            geoLocApiEndpoint: "https://geolocation-db.com/json/"
        },
        cookieLawZone: {
            countries: ['AT','BE','BG','HR','CY','CZ','DK','EE','FI','FR','DE','EL','HU','IE','IT','LV','LT','LU','MT','NL','PL','PT','RO','SK','SI','ES','SE','UK','EU'],
            stateCodes: ['CA','NV'], // Used on ipApiEndpoint
            states: ['California', 'Nevada'] // Used on geoLocApiEndpoint
        },
        cache: {
            enable: true,
            names: {
                clzCheck: "clzcheck" // CLZ: Cookie Law Zone
            }
        },
        testing: {
            enabled: true,
            param: "bnet-force-location",
            locations: {
                europeanunion: "eu"
            }
        }
    };

    var isCookieLawZone = function (istrue, isfalse) {

        ;
        if (_config.cache.enable) {
            var cache = storage.getSessionStorage(_config.cache.names.clzCheck);
            if (typeof( cache ) == 'boolean') {
                ;
                _handleResponseisCookieLawZone(cache, istrue, isfalse);
                return ;
            }
        }

        ;
        $.get(_config.api.geoLocApiEndpoint)
        .then(
            function success(response) {
                ;

                // Convert response to JSON object
                var response = JSON.parse(response);
                ;

                // Verify Cookie Law country and/or states.
                var result = ((response.country_code == 'US' && _config.cookieLawZone.states.includes(response.state))
                    || _config.cookieLawZone.countries.includes(response.country_code)) ? true : false;

                _handleResponseisCookieLawZone(result, istrue, isfalse);
            },
            function fail(data, status) {
                ;
                _handleResponseisCookieLawZone(false, istrue, isfalse);
            }
        );
    }
    
    var _handleResponseisCookieLawZone = function (response, istrue, isfalse) {
        if (_config.testing.enabled && utilities.getParameter(document.URL, _config.testing.param) == _config.testing.locations.europeanunion) {
            ;
            response = true;
        }

        if (response && typeof (istrue) == 'function') {
            ;
            storage.setSessionStorage(_config.cache.names.clzCheck, true);
            istrue();
        } else if (response === false && typeof (isfalse) == 'function') {
            ;
            storage.setSessionStorage(_config.cache.names.clzCheck, false);
            isfalse();
        } else {
            logging.error("Something went wrong with getting your information", _ModuleName);
        }
    }

    return {
        isCookieLawZone: isCookieLawZone
    }
});
